import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/testigos')({
  loader: async ({ context }) => {
    await context.getInstance('i18n', '@myn/mdm-hub');
  },
});
